// Runs the given function with the supplied object, then returns the object.
// Intented to run side-effects on the object which are not meant to be mutative or interupt the existing chain.
// Great for logging, message broadcasting, etc.
/* ex:
 * const p = Promise.resolve(3)
 * p
 *   .then(tap(log('before transform: ')))
 *   .then((n) => n * 2)
 *   .then(tap(log('after transform: ')))
 *
 * // before transform: 3
 * // after transform: 6
 */
// fn -> * -> *
export const tap = (fn) => (context) => {
    fn(context);
    return context;
};
//# sourceMappingURL=tap.js.map